<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PlainTable from '@components/plainTable'
import { ADMIN_ROLE } from '@utils/constant'
import { ErrorWrapper } from '@utils/error-handler'
import { reportComputed, reportListMethod, authComputed } from '@state/helpers'

export default {
  page: {
    title: 'Report List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PlainTable },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      isLoading: true,
      lists: [],
      fields: [],
    }
  },
  computed: {
    ...reportComputed,
    ...authComputed,
  },
  mounted() {
    this.getReport(this.$route.params.id)
  },
  beforeMount() {
    this.reportData = []
  },
  methods: {
    ...reportListMethod,

    // get report according to type
    getReport(route) {
      this.isLoading = true
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 10,
        sort: 'sort_order',
        order: '-1',
      }

      this.fetchReportDetails({ filter, route })
        .then((data) => {
          this.prepareField(route)
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },

    // set college field if user is admin
    setCollegeField() {
      if (this.role === this.ADMIN_ROLE) {
        this.fields.splice(3, 0, {
          key: 'collegeId',
          label: 'College',
          sortable: false,
          colType: 'default',
        })
      }
    },

    prepareField(route) {
      if (route === 'event') {
        this.fields = [
          {
            key: 'name',
            label: ' Event Name',
            sortable: false,
            colType: 'default',
          },
          {
            key: 'totalview',
            label: 'Total View',
            sortable: false,
            colType: 'default',
          },
          {
            key: 'totalsubscribes',
            label: 'Total Subscribed',
            sortable: false,
            colType: 'default',
          },
          {
            key: 'totalunsubscribes',
            label: 'Total Unsubscribed',
            sortable: false,
            colType: 'default',
          },
        ]
      } else if (route === 'course') {
        this.fields = [
          {
            key: 'name',
            label: ' Course Name',
            sortable: false,
            colType: 'default',
          },
          {
            key: 'totalview',
            label: 'Total View',
            sortable: false,
            colType: 'default',
          },
          {
            key: 'totaluserinprogress',
            label: 'Total In Progress',
            sortable: false,
            colType: 'default',
          },
          {
            key: 'totalusercompleted',
            label: 'Total Completed',
            sortable: false,
            colType: 'default',
          },
          {
            key: 'avgcourserating',
            label: 'Avg. Rating',
            sortable: false,
            colType: 'default',
          },
        ]
      } else if (route === 'feedback') {
        this.fields = [
          {
            key: 'createdAt',
            label: 'Date',
            sortable: false,
            colType: 'date',
          },
          {
            key: 'email',
            label: 'Email',
            sortable: false,
            colType: 'default',
          },
          {
            key: 'feedback',
            label: 'Feedback',
            sortable: false,
            colType: 'default',
          },
          {
            key: 'rating',
            label: 'Rating',
            sortable: false,
            colType: 'default',
          },
          {
            key: 'course',
            label: 'Course',
            sortable: false,
            colType: 'default',
          },
        ]
        this.setCollegeField()
      } else if (route === 'survey') {
        this.fields = [
          {
            key: 'createdAt',
            label: 'Date',
            sortable: false,
            colType: 'date',
          },
          {
            key: 'avg_rating',
            label: 'Avg. Rating',
            sortable: false,
            colType: 'default',
          },
          {
            key: 'question',
            label: 'Question / Answer',
            sortable: false,
            colType: 'question',
          },
        ]
      } else if (route === 'user') {
        this.fields = [
          {
            key: 'name',
            label: 'Name',
            sortable: false,
            colType: 'default',
          },
          {
            key: 'courseinprogress',
            label: 'Course In Progress',
            sortable: false,
            colType: 'default',
          },
          {
            key: 'coursecompleted',
            label: 'Course Completed',
            sortable: false,
            colType: 'default',
          },
          {
            key: 'eventsubscribed',
            label: 'Subscribed Event',
            sortable: false,
            colType: 'default',
          },
          {
            key: 'logincount',
            label: 'Login Count',
            sortable: false,
            colType: 'default',
          },
        ]
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
          <b-card v-if="reportData">
            <PlainTable
              :items="reportData ? reportData.docs : []"
              :fields="fields"
              :bordered="true"
              :per-page="reportData.limit"
              :total-rows="reportData.totalDocs"
              :current-page="reportData.page"
              :total-page="reportData.totalPages"
              :paging-counter="reportData.pagingCounter"
            ></PlainTable>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
